/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Upload_Tray_Embed_SelectedInputs */



/**
* | output |
* | --- |
* | "Embed {count} Selected" |
*
* @param {Upload_Tray_Embed_SelectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const upload_tray_embed_selected = /** @type {((inputs: Upload_Tray_Embed_SelectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Tray_Embed_SelectedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Ausgewählte einbetten`)
	return /** @type {LocalizedString} */ (`Embed ${i?.count} Selected`)
});